import React from 'react';

const ItalyPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-flag"></i>
          Italy - La Bella Italia
        </h1>
        <p>Celebrating our Italian heritage and the beauty of the homeland.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="italy-content">
            <p className="welcome-text">
              Italy is not just a country - it's the heart of our family's heritage.
              From the rolling hills of Tuscany to the ancient streets of Rome,
              from the canals of Venice to the coastal beauty of the Amalfi Coast,
              Italy represents our roots, our culture, and our identity.
            </p>

            <div className="heritage-section">
              <h3>Our Italian Roots</h3>
              <p>
                The De Marco and Rossetti families trace their origins back to Italy,
                carrying with them the traditions, values, and spirit that define
                Italian culture. Our connection to Italy goes beyond geography -
                it's about family, food, tradition, and a way of life that celebrates
                what truly matters.
              </p>
            </div>

            <div className="italian-values">
              <h3>Italian Values We Cherish</h3>
              <div className="values-grid">
                <div className="value-item">
                  <h4><i className="fas fa-users"></i> La Famiglia</h4>
                  <p>Family is everything - the foundation of life and source of strength</p>
                </div>
                
                <div className="value-item">
                  <h4><i className="fas fa-utensils"></i> Cibo e Tradizione</h4>
                  <p>Food and tradition bring people together and preserve our heritage</p>
                </div>
                
                <div className="value-item">
                  <h4><i className="fas fa-heart"></i> Passione</h4>
                  <p>Living with passion and appreciation for life's beautiful moments</p>
                </div>
                
                <div className="value-item">
                  <h4><i className="fas fa-handshake"></i> Rispetto</h4>
                  <p>Respect for elders, tradition, and the community around us</p>
                </div>
              </div>
            </div>

            <div className="cultural-connection">
              <h3>Keeping Italy Alive in America</h3>
              <p>
                While we've made America our home, we carry Italy with us every day.
                Whether it's through the recipes passed down through generations,
                the stories told at family gatherings, or the values that guide
                our decisions, Italy remains a vital part of who we are.
              </p>
              
              <p>
                From Sunday dinners that last for hours to the importance of
                maintaining strong family bonds, our Italian heritage shapes
                how we live, love, and connect with others.
              </p>
            </div>

            <div className="italy-memories">
              <h3>Bella Italia</h3>
              <p>
                <em>"L'Italia è il paese più bello del mondo"</em> - Italy is the most beautiful country in the world.
                This sentiment captures not just the physical beauty of Italy,
                but the beauty of its culture, its people, and the way of life
                that continues to inspire us every day.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItalyPage;